<script setup lang="ts">
import { useAppToastStore } from '@/stores/app-toast-store';

const toast = useAppToastStore();
</script>

<template>
  <Teleport to="body">
    <Transition name="app-toast">
      <p
        v-if="toast.open"
        class="app-toast"
        :class="`app-toast--${toast.kind}`"
        :role="toast.kind === 'error' ? 'alert' : 'status'"
      >
        {{ toast.text }}
      </p>
    </Transition>
  </Teleport>
</template>

<style scoped>
.app-toast {
  position: fixed;
  top: calc(5rem + env(safe-area-inset-top, 0px));
  left: 50%;
  z-index: 4300;
  box-sizing: border-box;
  max-width: min(80%, 20rem);
  margin: 0;
  padding: 0.4rem 0.64rem;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
  font-size: 0.64rem;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  overflow-wrap: anywhere;
  border-radius: 0.2133rem;
  transform: translateX(-50%);
  pointer-events: none;
}

.app-toast--ok {
  color: #fff;
  background: #178a45;
}

.app-toast--info {
  color: #1a1200;
  background: #e8b000;
}

.app-toast--error {
  color: #fff;
  background: #ee1e40;
}

.app-toast-enter-active,
.app-toast-leave-active {
  transition:
    opacity 0.2s cubic-bezier(0.16, 1, 0.3, 1),
    transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.app-toast-enter-from,
.app-toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -0.32rem);
}

@media (prefers-reduced-motion: reduce) {
  .app-toast-enter-active,
  .app-toast-leave-active {
    transition: opacity 0.15s linear;
  }

  .app-toast-enter-from,
  .app-toast-leave-to {
    transform: translateX(-50%);
  }
}
</style>
